import CloseIcon from "@mui/icons-material/Close";
import { Z_INDEX } from "constants/constants";
import { CollapseIcon, Header } from "../FlightDebuggerStyles";
import { getIsTouchDevice } from "utils/getIsTouchDevice";
import "jsoneditor-react/es/editor.min.css";
import { useDebuggerState, isFlightDebuggerOpenAtom } from "../debuggerUtils";
import { useAtom } from "jotai";
import { startTransition, useCallback } from "react";
import useWindowSize from "utils/customHooks/useWindowSize";

const isTouchDevice = getIsTouchDevice();
export function DebuggerHeader({ bindDragHandler }) {
  // once we've opened the popup, prevent further previews
  const [, setIsFlightDebuggerOpen] = useAtom(isFlightDebuggerOpenAtom);
  const { innerWidth } = useWindowSize();
  const handleClose = useCallback(() => {
    startTransition(() => {
      setIsFlightDebuggerOpen(false);
    });
  }, [setIsFlightDebuggerOpen]);
  const [{ collapsed }, setDebuggerState] = useDebuggerState();
  return (
    <Header
      $collapsed={collapsed}
      data-collapsed={collapsed}
      $customCss={`
              padding-left: 16px;
            `}
    >
      <div
        className="dragArea"
        {...(isTouchDevice && innerWidth < 600 ? {} : bindDragHandler())}
        onTouchStart={e => e.preventDefault()}
        onTouchMove={e => e.preventDefault()}
        style={{
          touchAction: "none", // Prevent browser touch handling
          userSelect: "none", // Prevent text selection during drag
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
        }}
      >
        Flight Debugger
      </div>
      <CollapseIcon
        $collapsed={collapsed}
        style={{
          zIndex: Z_INDEX.L10,
        }}
        onClick={() =>
          setDebuggerState(prev => ({ ...prev, collapsed: !prev.collapsed }))
        }
      />
      <CloseIcon
        style={{
          zIndex: Z_INDEX.L10,
        }}
        onClick={handleClose}
      />
    </Header>
  );
}
